import { abortIfNotPermitted } from '../utils';

export default [
    {
        // Screen 1 — campaign list for the selected outlet.
        path: '/',
        component: () =>
            import(/* webpackChunkName: "gamification-quota-index" */ '@js/franchise_component/customer-engagement/gamification/quota/gamification-quota-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_gamification_quota',
                next,
            );
        },
    },
    {
        // Screen 2 — locked-reward list for a campaign + outlet.
        path: '/campaign/:campaignId/rewards',
        component: () =>
            import(/* webpackChunkName: "gamification-quota-rewards" */ '@js/franchise_component/customer-engagement/gamification/quota/quota-reward-list.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_gamification_quota',
                next,
            );
        },
    },
];
